import { TEXTOS } from '../../../lib/glossario'

interface Props {
  /** O título do documento antigo, palavra por palavra. */
  titulo: string
  /** O campo do plano, como a API o devolve. */
  texto: string | null
  /** Afasta a tabela da anterior, como o `.mt` do documento antigo. */
  espacado?: boolean
}

/**
 * Um bloco de texto livre do RDM: faixa laranja com o título e uma célula alta embaixo.
 *
 * São seis no documento — objetivo, pré-requisitos, atividades da implantação, atividades de
 * teste, plano de rollback e teste de volta — e todos têm exatamente esta forma. Um
 * componente só, e não seis tabelas escritas à mão, porque foi assim que a view Blade
 * chegou a 365 linhas repetindo o mesmo `<table>`.
 *
 * A célula tem altura mínima mesmo vazia. Isso é herança do documento antigo e é
 * intencional: o RDM é impresso e assinado, e o espaço em branco é onde se escreve à mão o
 * que faltou. Campo vazio traz "Não informado" em vez de ficar mudo — quem lê o papel
 * precisa distinguir "ninguém preencheu" de "a impressão cortou".
 *
 * As quebras de linha digitadas pelo usuário aparecem porque a célula é `white-space:
 * pre-wrap`, e não porque alguém tenha convertido `\n` em `<br>`: injetar HTML aqui seria
 * pôr texto de formulário dentro da marcação da página.
 *
 * @param props título da faixa, conteúdo do campo e o espaçamento
 * @returns a tabela de uma seção de texto
 */
export function SecaoDeTexto({ titulo, texto, espacado = false }: Props) {
  return (
    <table className={espacado ? 'rdm-tabela rdm-espaco' : 'rdm-tabela'}>
      <thead>
        <tr>
          <th scope="col">{titulo}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="rdm-celula-alta">{texto?.trim() || TEXTOS.naoInformado}</td>
        </tr>
      </tbody>
    </table>
  )
}
